<template lang="pug">
  v-card
    .d-flex
      v-btn(@click="close" icon)
        v-icon(size="18") mdi-close-box
      span.pa-2 {{ item.text }}
    BaseCurrencyInputDynamicField(:currencyItems="currencyItems", :initialValue="initialValue" v-model="packages" @update="sendValue")
    BaseTextField.d-none(rules="required" v-model="packagesEmpty" type="hidden", :disabled="true")
</template>

<script>

  import { currencyList } from '@/store/variablesGlobals.js';

  export default {
    name: "FreespinsGameVariableCard",
    props: {
      item: {
        type: Object,
        default: function(){
          return {
            text: '',
            value: ''
          }
        }
      },
    },
    data:() =>({
      game: {
        text: '',
        value: '',
        packages: [],
      },
      initialValue: {
        currency: 'EUR',
        quantity: '0',
      },
      packagesEmpty: '',
      packages: [],
      currencyItems: currencyList.map(curr=> curr.text),
    }),
    methods:{
      close(){
        this.$emit('close', this.item.value);
      },
      sendValue(){
        this.packagesEmpty = this.packages.length > 0 ? 'true' : '';
        this.game.text = this.item.text;
        this.game.value = this.item.value;
        this.game.packages = this.packages;
        this.$emit('input', this.game);
      },
    },
  }
</script>

<style lang="sass">
</style>